<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
import * as req from '@/utils/request'
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  },
  updated () {
  },
  created () {
    this.getBranchList()
    this.getStationList()
    this.getShipList()
    this.startHeartBeat()
  },
  methods: {
    startHeartBeat () {
      this.heartBeat()
      let _this = this
      clearInterval(this.heartTime)
      this.heartTime = setInterval(function () {
        _this.heartBeat()
      }, 10000)
    },
    heartBeat () {
      if (!this.gmdss.user_info) {
        return
      }
      let sendData = {}
      let msg = {}
      msg.id = this.gmdss.user_info.id
      sendData.data = msg
      sendData.fn = this.setIntCollBack
      sendData.vm = null
      req.Get('user/heart', sendData)
    },
    setIntCollBack (data) {
      if (data === null) {
        // alert('服务器未连接')
        // window.location.href = window.$gmdss.loginURL
        this.$message.error('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        // window.location.href = window.$gmdss.loginURL
      }
    },
    // 倒计时
    // countDown () {
    //   setInterval(function () {
    //     _this.clock()
    //   }, 1000)
    // },
    // 选项跳转
    kaPian_Btn (data) {
      this.$router.push({path: data})
    },
    // 获取船舶列表
    getShipList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getShipListFn
      sendData.vm = this
      req.Get('ship/get_ship', sendData)
    },
    getShipListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
      window.$gmdss.getShip = data.list
    },

    getUserDatafn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.$router.push('/menuIndex')
    },
    // 获取部门
    getBranchList () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getBranchListFn
      sendData.vm = this
      req.Post('branch/get_branch', sendData)
    },
    getBranchListFn (data) {
      if (data.err_code !== 0) {
        this.$message(data.err_msg)
        return
      }
      let res = []
      for (let i in data.list) {
        if (data.list[i].branch === '岸基部') {
          break
        }
        res.push(data.list[i])
      }
      this.gmdss.BranchList = res
    },
    // 获取职位
    getStationList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getStationListFn
      sendData.vm = this
      req.Get('station/get_job', sendData)
    },
    getStationListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
      window.$gmdss.stationList = data.list
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    this.$router.push({ query: {} })
    location.reload()
    next()
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
*{
  /* width: 100%; */
  margin: 0;
  padding: 0;
}

body {
  margin: 0px;
  -moz-user-select: none; /*mozilar*/
  -webkit-user-select: none; /*webkit*/
  -ms-user-select: none; /*IE*/
  user-select: none;
  height: 100%;
  position: relative;
  background-color: rgb(230, 230, 230);
}
</style>



// WEBPACK FOOTER //
// src/App.vue